// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".blob{animation:pulse 2s infinite;background:var(--primary);border-radius:50%;box-shadow:0 0 0 0 var(--primary);height:14px;margin:10px;transform:scale(1);width:14px}@keyframes pulse{0%{box-shadow:0 0 0 0 var(--primaryAlpha);transform:scale(.95)}70%{box-shadow:0 0 0 10px transparent;transform:scale(1)}to{box-shadow:0 0 0 0 transparent;transform:scale(.95)}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
